<div class="grid">
  <div class="col-12">
    <h3 style="text-align: center; padding: 2px 5px;">
      {{'Mg_Pref' | translate}}
    </h3>
  </div>
</div>
<div class="grid">
  <div class="col-12 sm:col-12 md:col-12 lg:col-9 padtop">
    <button class="margin margb-5 sm:reset-btn" pButton type="button" (click)="onInitalize()" label="{{'Init_Def' | translate}}"></button>
    @if (isAdmin === true) {
      <button  class="margin margb-5 sm:reset-btn" pButton type="button" (click)="onApplyParam()" label="{{'Apply_Usr' | translate}}"></button>
    }
  </div>
  <div class="col-12 sm:col-12 md:col-12 lg:col-3 padtop">
    <h4>
      <div class="badge grey">{{'Vers_Num' | translate}} {{ version }}</div>
    </h4>
  </div>
</div>
<div class="grid">
  <!-- Interface -->
  <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
    <table class="table head" style="font-size: 14px;">
      <thead>
        <div class="grid paramt">
          <div class="col-6">{{'Intf' | translate}}</div>
          <div class="col-6">{{'Value' | translate}}</div>
        </div>
      </thead>
      <tbody>
        @for (request of requests; track request; let i = $index) {
          <tr>
            @switch (request.typepref) {
              @case (0) {
                <!-- 0 : Ecran par défaut -->
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availablePageList"
                      [(ngModel)]="screen.datapref"
                      (onChange)="onChangeValue(0)"
                      >
                    </p-dropdown>
                  </div>
                </td>                
              }
              @case (1) {
                <!-- 1 : Thème des composants -->
                <td>
                  <div class="grid">
                    <div class="col-6  word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableThemeList"
                      [(ngModel)]="theme.datapref"
                      (onChange)="onChangeTheme($event)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              @case (21) {
              <!-- 21 : Thème de la bannière -->
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableTopBarThemeList"
                      [(ngModel)]="topBarTheme.datapref"
                      (onChange)="onChangeTopBarTheme($event)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!-- 3 : Thème du menu -->
              @case(3) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown  class="col-6 align"
                      [options]="availableMenuThemeList"
                      [(ngModel)]="menuTheme.datapref"
                      (onChange)="onChangeMenuTheme($event)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }              
              <!-- 45 : Style des input -->
              @case (45) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableInputStyle"
                      [(ngModel)]="styleInput.datapref"
                      (onChange)="onChangeInputStyle($event)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!-- 4 : Style du menu -->
              @case (4) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableMenuList"
                      [(ngModel)]="styleMenu.datapref"
                      (onChange)="onChangeMenu($event)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!-- 22 : Taille de l'affichage -->
              @case (22) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableScale"
                      [(ngModel)]="scale.datapref"
                      (onChange)="onChangeValue(22)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!-- 26 : Mode de visualisation -->
              @case (26) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableModeView"
                      [(ngModel)]="modeView.datapref"
                      (onChange)="onChangeValue(26)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!-- 61 : Visualisation mode détail bannette -->
              @case (61) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableBskTabDetail"
                      [(ngModel)]="bskTabDetail.datapref"
                      (onChange)="onChangeValue(61)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
              <!--62 : Visualisation mode détail recherche -->
              @case (62) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <p-dropdown class="col-6 align"
                      [options]="availableSrcTabDetail"
                      [(ngModel)]="srcTabDetail.datapref"
                      (onChange)="onChangeValue(62)"
                      >
                    </p-dropdown>
                  </div>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
    <!-- Bannette -->
    <table class="table head" style="font-size: 14px;">
      <thead>
        <div class="grid paramt">
          <div class="col-6">{{'Basket' | translate}}</div>
          <div class="col-6">{{'Value' | translate}}</div>
        </div>
      </thead>
      <tbody>
        @for (request of requests; track request; let i = $index) {
          <tr>
            @switch (request.typepref) {
              <!-- 2 : Cacher le bannettes vides -->
              @case (2) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <div class="col-6 align margt-5">
                      <p-inputSwitch name="emptybsk" (onChange)="onChangeValue(2)" [(ngModel)]="emptyBskBool"></p-inputSwitch>
                    </div>
                  </div>
                </td>
              }
              <!-- 5 : Gradient des bannettes -->
              @case (5) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <div class="col-6 align margt-5">
                      <p-inputSwitch name="gradBsk" (onChange)="onChangeValue(5)" [(ngModel)]="gradBskBool"></p-inputSwitch>
                    </div>
                  </div>
                </td>
              }
              <!-- 20 : Document suivant après validation -->
              @case (20) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <div class="col-6 align margt-5">
                      <p-inputSwitch name="bskNextVal" (onChange)="onChangeValue(20)" [(ngModel)]="bskNextValBool"></p-inputSwitch>
                    </div>
                  </div>
                </td>
              }
              <!-- 54 : Bannette mode compacte -->
              @case (54) {
                <td>
                  <div class="grid">
                    <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                    <div class="col-6 align margt-5">
                      <p-inputSwitch name="bskCompact" (onChange)="onChangeValue(54)" [(ngModel)]="bskCompactBool"></p-inputSwitch>
                    </div>
                  </div>
                </td>
              }              
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  <!-- Tableau de bord -->
  <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
    <table class="table head" style="font-size: 14px;">
      <thead>
        <div class="grid paramt">
          <div class="col-6 word-break-all margauto">{{'defpage' | translate}}</div>
          <div class="col-6">{{'Value' | translate}}</div>
        </div>
      </thead>
      <tbody>
        <tr>
          <!-- 31 : Afficher les bannettes chargées -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(31)}}</div>
              <div class="col-6 align margt-5">
                <p-inputSwitch name="statLoad" (onChange)="onChangeValue(31)" [(ngModel)]="statLoadBool"></p-inputSwitch>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 9 : Bannettes chargées à afficher -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(9)}}</div>
              <p-dropdown class="col-6 align"
                [options]="availableBskLoadMax"
                [(ngModel)]="bskLoadMax.datapref"
                (onChange)="onChangeValue(9)"
                >
              </p-dropdown>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 30 : Afficher les dernières requêtes -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(30)}}</div>
              <div class="col-6 align margt-5">
                <p-inputSwitch name="reqLast" (onChange)="onChangeValue(30)" [(ngModel)]="lastReqBool"></p-inputSwitch>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 24 : Nombre de requêtes à afficher -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(24)}}</div>
              <p-dropdown class="col-6 align"
                [options]="availableReqLoadMax"
                [(ngModel)]="reqLoadMax.datapref"
                (onChange)="onChangeValue(24)"
                >
              </p-dropdown>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 29 : Afficher les anciens documents -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(29)}}</div>
              <div class="col-6 align margt-5">
                <p-inputSwitch name="statOldDoc" (onChange)="onChangeValue(29)" [(ngModel)]="statOldDocBool"></p-inputSwitch>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 32 : Afficher les documents consultés -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(32)}}</div>
              <div class="col-6 align margt-5">
                <p-inputSwitch name="statView" (onChange)="onChangeValue(32)" [(ngModel)]="statViewBool"></p-inputSwitch>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 33 : Afficher les documents traités -->
          <td>
            <div class="grid">
              <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(33)}}</div>
              <div class="col-6 align margt-5">
                <p-inputSwitch name="statWork" (onChange)="onChangeValue(33)" [(ngModel)]="statWorkBool"></p-inputSwitch>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 6 : Afficher nombre de document intégrés -->
          @if (isAdmin === true) {
            <td>
              <div class="grid">
                <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(6)}}</div>
                <div class="col-6 align margt-5">
                  <p-inputSwitch name="statNbDoc" (onChange)="onChangeValue(6)" [(ngModel)]="statNbDocBool"></p-inputSwitch>
                </div>
              </div>
            </td>
          }
        </tr>
        <tr>

          <!-- 7 : Style du diagramme -->
          @if (isAdmin === true) {
            <td>
              <div class="grid">
                <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(7)}}</div>
                <p-dropdown class="col-6 align"
                  [options]="availableStatStyle"
                  [(ngModel)]="statStyle.datapref"
                  (onChange)="onChangeValue(7)"
                  >
                </p-dropdown>
              </div>
            </td>
          }
        </tr>
        <tr>
          <!-- 8 : Période stat intégration -->
          @if (isAdmin === true) {
            <td>
              <div class="grid">
                <div class="col-6 word-break-all margauto"> {{getLabelOfTypePref(8)}}</div>
                <p-dropdown class="col-6 align"
                  [options]="availableStatPer"
                  [(ngModel)]="statPer.datapref"
                  (onChange)="onChangeValue(8)"
                  >
                </p-dropdown>
              </div>
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-item-confirm [key]="'init'" [severity]="'warning'" (onAccept)="initialize()"></app-item-confirm>
<app-item-confirm [key]="'params'" [severity]="'warning'" (onAccept)="applyParam()"></app-item-confirm>